export default __webpack_public_path__ + "static/media/dra-isabela.94539f93.png";